import React, { useEffect, useState } from 'react';
import HeaderStyleThree from '../../components/Layout/Header/HeaderStyleThree';
import Footer from '../../components/Layout/Footer';
import BackToTop from '../../components/elements/BackToTop';
import CTFHero from './CTFHero';
import CTFSection from '../home-3/CTFSection';
import { supabase } from '../../supabaseClient';
import defaultCtfData from '../../data/ctf.json';

const CTFPage = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [ctfData, setCtfData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const handleScroll = () => setIsVisible(window.scrollY > 300);
        document.addEventListener('scroll', handleScroll);
        
        const fetchCtfData = async () => {
            try {
                const { data, error } = await supabase
                    .from('ctf_page_content')
                    .select('*')
                    .eq('page_name', 'ctf-page')
                    .single();
                    
                if (error || !data) {
                    setCtfData(defaultCtfData);
                } else {
                    setCtfData(data.data);
                }
            } catch (err) {
                setCtfData(defaultCtfData);
            }
            setLoading(false);
        };
        
        fetchCtfData();

        return () => document.removeEventListener('scroll', handleScroll);
    }, []);

    if (loading) {
        return (
            <div className="homestyle2" style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'var(--eventflow-black)' }}>
                <div className="spinner-border text-light" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="homestyle2">
            <HeaderStyleThree />
            <CTFHero ctfData={ctfData} />
            <CTFSection ctfData={ctfData} />
            <BackToTop scroll={isVisible} />
            <Footer />
        </div>
    );
};

export default CTFPage;
